<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/plans'"
            >Plans</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link to="" style="color: #8cc63f !important">
            Create
          </router-link>
        </li>
      </ol>
    </div>
    <div class="col-12" style="margin-top: 60px">
      <plan-form formType="create" @savePlan="createPlan"></plan-form>
    </div>
  </div>
</template>
<script>
import PlanForm from "./forms/planForm.vue";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
export default {
  data() {
    return {
      validationMsg: null,
    };
  },
  components: {
    PlanForm,
  },
  methods: {
    formValidation(plan) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";
      if (plan.name.length < 2) {
        missingFieldsString += "Plan name is less than 2 characters, ";
        result.isValid = false;
      }
      if (plan.min_principal <= 0) {
        missingFieldsString +=
          "Plan minimum allowed capital is less than or equal zero, ";
        result.isValid = false;
      }
      if (plan.max_principal <= 0) {
        missingFieldsString +=
          "Plan maximun allowed capital is less than or equal zero, ";
        result.isValid = false;
      }
      if (plan.max_principal < plan.min_principal) {
        missingFieldsString +=
          "Plan maximun allowed capital is less than minimum allowed capital, ";
        result.isValid = false;
      }
      if (plan.withdrawal_notice < 0) {
        missingFieldsString += "Plan withdrawal notice is less than zero, ";
        result.isValid = false;
      }
      if (plan.min_period <= 0) {
        missingFieldsString +=
          "Plan minimum period is less than zero or equal, ";
        result.isValid = false;
      }
      let periodList = ["day", "week", "month", "year"];
      if (!periodList.includes(plan.period)) {
        missingFieldsString += "Plan period should be selected, ";
        result.isValid = false;
      }
      if (!periodList.includes(plan.withdrawal_notice_period)) {
        missingFieldsString +=
          "Plan withdrawal notice period should be selected, ";
        result.isValid = false;
      }
      if (plan.allocation_type == "clusters") {
        let totalClusterWeights = 0;
        plan.clusterWeights.forEach((planClusterWeight) => {
          totalClusterWeights += planClusterWeight.weight;
        });
        if (totalClusterWeights != 100) {
          missingFieldsString +=
            "The sum of the plan allocation should be equal to 100, ";
          result.isValid = false;
        }
      } else if (plan.allocation_type == "projects") {
        let totalProjectWeights = 0;
        plan.projectWeights.forEach((planProjectWeight) => {
          totalProjectWeights += planProjectWeight.weight;
        });
        if (totalProjectWeights != 100) {
          missingFieldsString +=
            "The sum of the plan allocation should be equal to 100, ";
          result.isValid = false;
        }
      } else {
        missingFieldsString += "Plan allocation type is not selected, ";
        result.isValid = false;
      }
      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    createPlan(plan) {
      const { isValid, message } = this.formValidation(plan);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      this.$store.dispatch("createPlan", plan);
    },
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      createPlanStatus: (state) => state.planStore.planCreate.createPlanStatus,
    }),
  },
  watch: {
    createPlanStatus() {
      if (this.createPlanStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Plan has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/plans");
        });
      } else if (this.createPlanStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Plan creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/createPlan.vue